module.exports = __webpack_public_path__ + "img/Cardailsgs.79729360.png";